// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"77b816bf","462":"c09e2045","869":"39dcd486"}[chunkId] + ".chunk.js";
};